<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 국립공주대와 `부동산학과 재학생 교육 지원` 업무 협약 체결</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_09.jpg"></figure>
                                <br>
                                <br>
                                에듀윌이 지난 6월 29일 서울 역삼동에 위치한 에듀윌 부동산아카데미 강남캠퍼스에서 국립공주대학교 재학생들의 교육 지원을 위한 업무협약을 맺었다고 30일
                                밝혔다.
                                <br><br>
                                이날 협약식에는 에듀윌 학원사업부문 심유순 본부장과 국립공주대학교 부동산학과 김재환 학과장, 김진희 교수, 심희철 교수 등이 참석했다.
                                <br><br>
                                이번 협약은 국립공주대학교 부동산학과 재학생들이 공인중개사 1위 에듀윌 부동산아카데미의 부동산 실무 교육 과정, 공인중개사를 비롯한 각종 자격증 취득 과정과
                                공무원 교육 과정 등 에듀윌이 운영하고 있는 교육 과정 수강 시 수강료 할인 등의 혜택을 제공하는 것이 골자다.
                                <br><br>
                                이날 행사에는 국립공주대학교 부동산학과 학생들도 직접 참여해 의미를 더했다. 에듀윌 부동산아카데미는 멀리서 직접 발걸음해준 학생들을 위해 강남캠퍼스 투어,
                                기념품 전달 등을 진행하며 협약을 자축했다.
                                <br><br>
                                에듀윌 심유순 본부장은 "사회 진출을 앞둔 대학생 여러분이 에듀윌을 통해 더 탄탄히 미래를 준비할 수 있도록 적극 지원할 예정이다. 공주대 부동산학과와의
                                협약을 시작으로 더 많은 학생들에게도 좋은 기회를 제공할 수 있도록 노력하겠다"고 말했다.

                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news8" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 사이버보안 교육 과정 신규 런칭…’보안전문가’ 양성</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news1" data-value="315283">
                                        <strong>다음</strong>
                                        <span>에듀윌, 서울시 교육복지사업 ‘서울런’ 참여…검정고시·자격증 최신 강좌 지원</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
